import { createSlice } from "@reduxjs/toolkit";

const productsSlice = createSlice({
  name: "products",
  initialState: {
    productsArray:[]
  },
  reducers: {
    getAllProducts: (state, action) => {
  state.productsArray =action.payload;
 },
 },
});

export const { getAllProducts } = productsSlice.actions;
export default productsSlice.reducer;
